export default __webpack_public_path__ + "static/media/instagram.161d68df.svg";